import { game_skill } from '../api/entities';

export const actions = {
  listGameSkill: 'LIST_GAME_SKILL',
};

export function getGameSkills() {
  return game_skill.list(actions.listGameSkill, null, null, true);
}

const INITIAL_STATE = {
  game_skills: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listGameSkill:
      return {
        ...state,
        game_skills: action.body ? action.body._items : state.game_skills,
      };
    default:
      return {
        ...state,
      };
  }
}
